export default "__VITE_ASSET__af96fc67__"